<script lang="ts">
	import { classes } from '@thearc-hq/ui-kit/utils';

	// Use to override the default class
	export let defaultClass = 'my-2 border-gray border-opacity-[0.5]';
	export let additionalClass = '';
</script>

<hr class={classes(defaultClass, additionalClass)} {...$$restProps} />
